import BuildItemSkeleton from '@/components/BuildListItem/BuildItemSkeleton';

type BuildListSkeletonContentProps = {
  count: number;
  canRunBuild?: boolean;
  showAppInfo?: boolean;
};
const BuildListSkeletonContent = ({
  count,
  canRunBuild = false,
  showAppInfo = true,
}: BuildListSkeletonContentProps) => (
  <>
    {Array(count)
      .fill(0)
      .map((_, idx) => idx)
      .map((val) => (
        <BuildItemSkeleton key={val} canRunBuild={canRunBuild} showAppInfo={showAppInfo} />
      ))}
  </>
);

export default BuildListSkeletonContent;
